import React, {Component} from 'react';
import ViewHeader from '../../containers/Layouts/Admin/view-header';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import _ from "lodash";


class Details extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterData: null
        }
        this.formatId = this.formatId.bind(this);
    }

    componentDidMount() {
        if (this.table && this.props.filterData) {
            this.table.handleFilterData(this.props.filterData);
        }
    }

    afterColumnFilter(filterConds) {
        if(filterConds && !_.isEqual(filterConds, this.props.filterData)) {
            this.props.handleFilterDataChange(filterConds);
        }
    }

    formatId(cell, row) {
        return <div onClick={() => this.props.linkToCase(row)}> {cell} </div>
    }

    getFilterDefaultValue(filterName, fieldType) {
        const filterData = this.props.filterData;
        if(fieldType === 'text') {
            return filterData && filterData[filterName] ? filterData[filterName].value : null
        }
        return filterData && filterData[filterName] ? filterData[filterName].value[fieldType] : null
    }

    getGoBackButtonProps() {
        const { state } =  this.props.location;
        const isTherePageName = this.props.location.state && this.props.location.state.pageName;

        return {
            showBackIcon: true,
            history: this.props.history,
            title: `Go Back to ${ isTherePageName ? state.pageName : state.filterData.state.pageName }`,
            goBackHandler: isTherePageName ? () => this.props.handleGoBack(this.props.location) : () => this.props.handleGoBack(this.props.location.state.filterData)
        }
    }

    render() {
        const header = this.props.header;
        const desc = this.props.desc;
        const dentistOptions = this.props.option;
        dentistOptions.afterColumnFilter = (filterConds) => this.afterColumnFilter(filterConds);
        return (<div className="view">
            <ViewHeader
                header={header}
                desc={desc}
                {...this.getGoBackButtonProps()}
            />

            <div className="view-content view-dashboard">
                <div className="">
                    <div className="table-block">
                        { this.props.isPatient ?
                            <BootstrapTable ref={c => this.table = c} data={this.props.details} options={ dentistOptions } pagination striped ignoreSinglePage>
                                <TableHeaderColumn width="200" isKey dataField='bookingId' dataFormat={this.formatId} filter={ { type: 'NumberFilter', placeholder: 'Search', defaultValue: {number: this.getFilterDefaultValue('bookingId', 'number'), comparator: '='} } } dataSort={ true }>Case ID</TableHeaderColumn>
                                <TableHeaderColumn width="200" dataField='units' filter={ { type: 'NumberFilter', placeholder: 'Search', defaultValue: {number: this.getFilterDefaultValue('units', 'number'), comparator: '='} } } dataSort={ true }>Units</TableHeaderColumn>
                            </BootstrapTable>
                            :
                            <BootstrapTable ref={c => this.table = c} data={this.props.details} options={ dentistOptions } pagination striped ignoreSinglePage>
                                <TableHeaderColumn className="mr-field" width="200" dataField='patientName' filter={ { type: 'TextFilter', placeholder: 'Search' , defaultValue: this.getFilterDefaultValue('patientName', 'text')} }  dataSort={ true }>Patient Name</TableHeaderColumn>
                                <TableHeaderColumn width="200" isKey dataField='bookingId' columnClassName={"td-id"} dataFormat={this.formatId} filter={ { type: 'NumberFilter', placeholder: 'Search', defaultValue: {number: this.getFilterDefaultValue('bookingId', 'number'),  comparator: '='} } } dataSort={ true }>Case ID</TableHeaderColumn>
                                <TableHeaderColumn width="200" dataField='units' filter={ { type: 'NumberFilter', placeholder: 'Search', defaultValue: {number: this.getFilterDefaultValue('units', 'number'),  comparator: '='} } } dataSort={ true }>Units</TableHeaderColumn>
                            </BootstrapTable>
                        }
                    </div>
                </div>
            </div>
        </div>)
    }
}

export default Details;



// WEBPACK FOOTER //
// ./src/components/Details/Details.js